<template>

  <head>

    <meta charset="utf-8" />
    <title>Hotline Transporters Sacco | All invoices</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">


    <NavigationBar/>


    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Ward Targets</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Set Ups</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Revenue Targets</a></li>
                    <li class="breadcrumb-item active">Ward Targets</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>

          <!-- tool bar -->

          <!-- <ToolBarTargets/>-->

          <ToolBarTargets/>
          <!-- end of toolbar -->

          <!-- target cards -->

          <!-- end of target cards -->
          <!-- end page title -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div
                    class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">

                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100"
                       role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input v-model="searchQuery" type="text"
                                 class="form-control bg-light border-light rounded"
                                 placeholder="Search..." fdprocessedid="husj3l">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">

                      <button data-bs-toggle="modal" data-bs-target=".updownload-modal"
                              type="button"
                              class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize">
                        <i class="mdi mdi-microsoft-excel font-size-16"></i> <span
                          class="pl-1 d-md-inline">Upload Excel File</span>
                      </button>

                      <button data-bs-toggle="modal" data-bs-target=".download-modal"
                              type="button"
                              class="btn btn-success dropdown-toggle option-selector me-3 text-capitalize ">
                        <i class="dripicons-download font-size-16"></i> <span
                          class="pl-1 d-md-inline">Download</span>
                      </button>

                    </div>


                  </div>

                </div>
                <div class="card-body">
                  <div class="table-responsive overflow-visible">

                    <table class="table align-middle table-hover  contacts-table" id="">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th>#</th>
                        <th scope="col">Ward Name</th>
                        <th class="text-right">Daily Target</th>
                        <th class="text-right">Monthly Target</th>
                        <th class="text-right">Financial Year Target</th>
                        <th></th>

                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" :value="item" v-for="(item, index) in filteredWards">
                        <th>{{index+1}}.</th>

                        <td class="">
                          {{item.wardName}}
                        </td>
                        <td class="text-right">
                          KES {{numberFormat(item.dailyTargets)}}
                        </td>
                        <td class="text-right">
                          KES {{numberFormat(item.monthlyTargets)}}
                        </td>
                        <td class="text-right">
                          KES {{numberFormat(item.financialYearTargets)}}
                        </td>

                        <td>
                          <button @click="selectedWard(item)" data-bs-toggle="modal" data-bs-target=".target-modal"
                                  class="btn btn-primary btn-sm"><i
                              class="mdi mdi-file-document-edit-outline"></i>
                            Edit</button>
                        </td>
                      </tr>




                      </tbody>

                    </table>
                  </div>

                </div>

                <div class="card-footer bg-white">
                  <nav aria-label="Page navigation example "
                       class="d-flex align-items-center justify-content-between">

                    <div class="d-flex align-items-center">
                                            <span class="pr-3 pb-0 mb-0 font-13px">
                                                <span>Rows Per Page</span>
                                            </span>
                      <select v-model="rowsPerPage" @change="updatePagination" class="form-select w-auto font-13px ">
                        <option value="10">10 Rows</option>
                        <option value="25">25 Rows</option>
                        <option value="50">50 Rows</option>
                        <option value="100">100 Rows</option>
                        <option value="150">150 Rows</option>
                        <option value="200">200 Rows</option>
                      </select>
                    </div>

                    <ul class="pagination">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" href="javascript: void(0);" @click.prevent="previousPage" tabindex="-1">Previous</a>
                      </li>
                      <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
                        <a class="page-link" href="javascript: void(0);" @click.prevent="goToPage(page)">{{page}}</a>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <a class="page-link" href="javascript: void(0);" @click.prevent="nextPage">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- receipting modal -->
      <div class="modal fade updownload-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Ward Targets Upload</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <address>
                    <strong class="text-capitalize">Revenue Target for The Year</strong><br>
                    2023/2024
                  </address>
                </div>

                <div class="col-12">
                  <address>
                    <strong class="text-capitalize">Sample Excel Sheet</strong><br>
                    <p><a href="javascript: void(0);"><i class="mdi mdi-download"></i> Download Sample Excel File</a>
                    </p>
                  </address>
                </div>

                <div class="col-12">
                  <label><strong>Select the file</strong></label>
                </div>
                <div class="col-12">
                  <div>
                    <form action="#" class="dropzone">
                      <div class="fallback">
                        <input name="file" type="file" multiple="multiple">
                      </div>
                      <div class="dz-message needsclick">
                        <div class="mb-3">
                          <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                        </div>

                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </form>
                  </div>
                </div>



                <div class="col-12">
                  <button type="button"
                          class="btn btn-primary dropdown-toggle option-selector text-capitalize w-100 mt-5">
                    <i class="bx bxs-download  font-size-16"></i> <span
                      class="pl-1 d-md-inline">Upload Excel File</span>
                  </button>
                </div>

              </div>

            </div>

          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- end of receipting modal -->

      <!-- setting target -->
      <div class="modal fade target-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Collections Targets for {{ward.wardName}}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">

                <!-- calculated by dividing FY target by 365 -->

                <div class="col-12">
                  <label><strong>Daily Target Amount</strong></label>
                </div>
                <div class="col-12 mb-3">
                  <input v-model="ward.dailyTargets" class="form-control" type="text" placeholder="Enter Amount">
                </div>

                <!-- calculated by dividing FY targets by 12 -->

                <div class="col-12">
                  <label><strong>Monthly Target</strong></label>
                </div>
                <div class="col-12 mb-3">
                  <input v-model="ward.monthlyTargets" class="form-control" type="text" placeholder="Enter Amount">
                </div>

                <!-- this is what has been provided -->

                <div class="col-12">
                  <label><strong>Financial Year Target</strong></label>
                </div>
                <div class="col-12 mb-3">
                  <input  v-model="ward.financialYearTargets" class="form-control" type="text" placeholder="Enter Amount">
                </div>



                <div class="col-12">
                  <button @click="updateWardTargets()" type="button" data-bs-dismiss="modal"
                          class="btn btn-primary dropdown-toggle option-selector text-capitalize w-100 mt-5">
                    <i class="mdi mdi-content-save-all  font-size-16"></i> <span
                      class="pl-1 d-md-inline">Save Changes</span>
                  </button>
                </div>

              </div>

            </div>

          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- end of target setting -->

      <!-- download modaL -->
      <div class="modal fade download-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Download Ward Targets</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <address>
                    <strong class="text-capitalize">Report Title</strong><br>
                    Revenue Collections By Wards in  County
                  </address>
                </div>



                <div class="col-12">
                  <label><strong>Select File Type</strong></label>
                  <select class="form-select">
                    <option>Select Document Type</option>
                    <option>PDF file</option>
                    <option>Excel File</option>
                  </select>
                </div>

                <div class="col-12">
                  <button  type="button" class="btn btn-primary dropdown-toggle option-selector text-capitalize w-100 mt-5">
                    <i class="bx bxs-download  font-size-16"></i> <span class="pl-1 d-md-inline">Download Report</span>
                  </button>
                </div>

              </div>

            </div>

          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- END OF DOWNLOAD MODAL -->

      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">

            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                County Government
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay "></div>

  </body>


</template>

<script>

import ToolBarTargets from "@/components/systemsettings/ToolBarTargets";
import NavigationBar from "@/components/Navigation";
import {biller, execute} from "@/api";
export default {
  name: "TargetsWard",
  components: {NavigationBar, ToolBarTargets},
  data() {
    return {
      wards:[
        {
          wardName: null,
          wardID: null,
          dailyTargets: null,
          monthlyTargets: null,
          financialYearTargets: null
        }
      ],
      ward:
          {
            wardName: null,
            wardID: null,
            dailyTargets: null,
            monthlyTargets: null,
            financialYearTargets: null
          }
      ,
      searchQuery: '',
      currentPage: 1,
      rowsPerPage: 10,
      message: ''
    };
  },
  computed: {
    filteredWards() {
      let filtered = this.wards;

      // Apply search filter
      if (this.searchQuery) {
        filtered = filtered.filter(ward =>
            ward.wardName.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }

      // Apply pagination
      const start = (this.currentPage - 1) * this.rowsPerPage;
      const end = start + this.rowsPerPage;

      return filtered.slice(start, end);
    },
    totalPages() {
      const filtered = this.searchQuery
          ? this.wards.filter(ward =>
              ward.wardName.toLowerCase().includes(this.searchQuery.toLowerCase())
          )
          : this.wards;

      return Math.ceil(filtered.length / this.rowsPerPage);
    }
  },
  mounted() {
    this.getWardTargets()
    this.menuAccess()
  },
  methods:{

    menuAccess(){

      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Targets Ward");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then(() => {
            // alert(res.data.message);
          })
          .catch(() => {
            // alert(e.message);
          });

    },

    selectedWard(item) {
      this.ward = {...item}; // Create a copy to avoid direct mutation
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    },

    getWardTargets() {
      const data = new FormData();
      data.append("function", "getWardTargets");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            //alert(e.message);
            this.message = e.message
          });
    },

    updateWardTargets() {
      const data = new FormData();
      data.append("function", "updateWardTargets");
      data.append("ward", JSON.stringify(this.ward));
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              // Update the ward in the wards array
              const index = this.wards.findIndex(w => w.wardID === this.ward.wardID);
              if (index !== -1) {
                this.wards[index] = {...this.ward};
              }

              // Show success message
              this.message = "Ward targets updated successfully";

              // Refresh the data
              this.getWardTargets();
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            //alert(e.message);
            this.message = e.message
          });
    },

    // Pagination methods
    updatePagination() {
      this.currentPage = 1; // Reset to first page when changing rows per page
    },

    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    goToPage(page) {
      this.currentPage = page;
    }
  }
}
</script>

<style scoped>
.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.pagination {
  margin-bottom: 0;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.page-item.active .page-link {
  background-color: #556ee6;
  border-color: #556ee6;
}
</style>